/**
 * <kj-bundle target="<quantity input id>"> — bundle picker (buy 1 / 2 / 3).
 * Choosing an option writes its quantity into the product form's quantity input,
 * so Add to cart and Buy now submit the bundle size.
 */
class KjBundle extends HTMLElement {
  #onChange = (event) => {
    const radio = event.target;
    if (!(radio instanceof HTMLInputElement) || radio.type !== 'radio') return;
    const input = document.getElementById(this.getAttribute('target'));
    if (!input) return;
    input.value = radio.value;
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  };

  connectedCallback() {
    this.addEventListener('change', this.#onChange);
    const checked = this.querySelector('input[type="radio"]:checked');
    const input = document.getElementById(this.getAttribute('target'));
    if (checked && input) input.value = checked.value;
  }

  disconnectedCallback() {
    this.removeEventListener('change', this.#onChange);
  }
}

if (!customElements.get('kj-bundle')) customElements.define('kj-bundle', KjBundle);
